module.exports = __webpack_public_path__ + "img/Vector.2296f7bf.svg";